import * as actions from '../../../store/actions';

export const createForm = (form) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.CREATE_FORM_START
        });
        const firestore = getFirestore();
        const profile = getState().firebase.profile
        const profileUid = getState().firebase.auth.uid
        firestore.collection('forms').add({
            ...form,
            authorDisplayName: (profile.displayName || ''),
            authorId: profileUid,
            createdAt: new Date(),
        }).then(() => {
            dispatch({
                type: actions.CREATE_FORM_SUCCESS,
                payload: form
            });
        }).catch((err) => {
            dispatch({
                type: actions.CREATE_FORM_ERROR,
                payload:err
            })
        })
    }
}

export const createFormReset = () => {
    return (dispatch) => {
        dispatch({
            type: actions.CREATE_FORM_RESET
        });
    }
}